<template>
    <div class="main main-padding tabs-data-detailcs">
        <!--区域选择-->
        <!-- <div style="padding-top: 20px;padding-left: 10px;" v-if="dataIndex == 0">
            <area-select
                @query-table-data="queryTableData"
            ></area-select>
        </div> -->
        <!--数据信息-->
        <card>
            <!--头部tab及搜索框-->
            <div class="card-header-area">
                <!--tab切换数据-->
                <div class="tab-data">
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
                        <TabPane label="学校使用白板排名" name="schoolUseBoardRank"></TabPane>
                        <!-- <TabPane label="用户使用白板排名" name="userUseBoardRank"></TabPane> -->
                    </Tabs>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        :placeholder="placeholder"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--学校使用白板排名-->
                <div class="table-wrapper-data" v-if="dataIndex===0">
                    <Table :columns="schoolBoardColumn" :data="schoolBoardList"></Table>
                </div>
                <!--用户使用白板排名-->
                <div class="table-wrapper-data" v-if="dataIndex===1">
                    <Table :columns="userBoardColumn" :data="userBoardList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {
        querySchoolWihteBoardRankList,
        queryUserRankList
    } from "../../../service/api.js";
    const AreaSelect = () => import("../../../components/AreaSelect");//引入地区选择组件
    export default {
        name: "data-details-tab",
        components: {
            AreaSelect
        },
        data () {
            return {
                keyWord: "",//关键字
                page: 1,//当前页面
                limit: 10,//页面数据数量
                total: 0,//页面数据总数
                pageCount: 0,//页数
                dataIndex: 0,//默认显示学校使用白板排名数据
                schoolBoardList: [],//学校使用白板排名集合
                userBoardList: [],//用户使用白板排名集合
                placeholder: "支持学校名称关键字搜索",//搜索框提示语
                filters: {
                    provinceId: "", //省
                    cityId: "", //市
                    districtId: "" //区，县
                },
                schoolBoardColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "学校名称",
                        key: "school_name",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "查看用户列表",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookUserList(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.school_name
                                )
                            ]);
                        }
                    },
                    // {
                    //     title: "使用白板的教师数量",
                    //     key: "teacherCount",
                    //     align: "center"
                    // },
                    {
                        title: "白板数量",
                        key: "whiteboardidCount",
                        align: "center"
                    }
                ],
                userBoardColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户姓名",
                        key: "realname",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "查看用户列表",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookUserDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.realname
                                )
                            ]);
                        }
                    },
                    {
                        title: "用户所在学校",
                        key: "school_name",
                        align: "center"
                    },
                    {
                        title: "手机号",
                        key: "mobile",
                        align: "center"
                    },
                    {
                        title: "用户名",
                        key: "user_name",
                        align: "center"
                    },
                    {
                        title: "用户使用白板数",
                        key: "whiteboardCount",
                        align: "center"
                    }
                ]
            }
        },
        methods: {
            /**
             * 选择省市县查询
             */
            queryTableData (provinceId, cityId, districtId) {
                let _this = this;
                _this.filters.provinceId = provinceId;
                _this.filters.cityId = cityId;
                _this.filters.districtId = districtId;
                _this.total = 0;
                _this.page = 1;
                if (_this.dataIndex == 0) {
                    //获取学校白班统计
                    _this.findSchoolWihteBoardRankList();
                } else if (_this.dataIndex == 1) {
                    //获取用户白板统计
                    _this.findUserRankList();
                }
            },
            /**
             * 点击tab切换数据信息
             */
            changeDataDetailsIndex (tabsName) {
                //初始化参数
                this.keyWord = "";
                this.page = 1;
                this.total = 0;
                this.pageCount = 0;
                if (tabsName == 'schoolUseBoardRank') {
                    //显示学校使用白板排名
                    this.dataIndex = 0;
                    this.placeholder = "支持学校名称关键字搜索";
                    this.findSchoolWihteBoardRankList();
                } else if (tabsName == 'userUseBoardRank') {
                    //获取用户白板统计
                    this.dataIndex = 1;
                    this.placeholder = "支持用户名称关键字搜索";
                    this.findUserRankList();
                }
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                if (this.dataIndex == 0) {
                    //获取学校白班统计
                    this.findSchoolWihteBoardRankList();
                } else if (this.dataIndex == 1) {
                    //获取用户白板统计
                    this.findUserRankList();
                }
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                if (this.dataIndex == 0) {
                    //获取学校白班统计
                    this.findSchoolWihteBoardRankList();
                } else if (this.dataIndex == 1) {
                    //获取用户白板统计
                    this.findUserRankList();
                }
            },
            /**
             *获取学校白班统计
             */
            async findSchoolWihteBoardRankList () {
                let _this = this;
                let params = {
                    provinceid: _this.filters.provinceId,
                    cityid: _this.filters.cityId,
                    districtid: _this.filters.districtId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await querySchoolWihteBoardRankList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.schoolBoardList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取用户白板统计
             */
            async findUserRankList () {
                let _this = this;
                let params = {
                    schoolId: "",
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await queryUserRankList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.userBoardList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },

            /**
             * 点击查看用户列表
             */
            lookUserList (row) {
                this.$router.push({
                    name: "cloudBoardUserList",
                    query: {
                        schoolId: row.schoolid
                    }
                });
            },
            /**
             * 点击查看用户使用白板详情
             */
            lookUserDetails (row) {
                let routeData = this.$router.resolve({
                    name: "userBoardDetails",
                    query: {
                        userId: row.userid
                    }
                });
                window.open(routeData.href, '_blank');
            }
        },
        mounted () {
            //获取学校白班统计
            this.findSchoolWihteBoardRankList();
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", '云白板');
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";

    .laypage_main {
        position: absolute;
        bottom: 15px;
        right: 15px;
    }
</style>
<style lang="scss">
    .tabs-data-detailcs {
        .data-cloud-ive {

        }

        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card {
            margin-top: 50px !important;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
